import { render, staticRenderFns } from "./InvoicePdf.vue?vue&type=template&id=cbb3724c&scoped=true&"
import script from "./InvoicePdf.vue?vue&type=script&lang=js&"
export * from "./InvoicePdf.vue?vue&type=script&lang=js&"
import style0 from "./InvoicePdf.vue?vue&type=style&index=0&id=cbb3724c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbb3724c",
  null
  
)

export default component.exports